import { useEffect, useState } from "react";
import { ApiResponse } from "../../../api/master/axiosIndex";
import { useLocation } from "react-router";
import { RootState } from "../../../store/store";
import { useSelector } from "react-redux";
import { Card } from "antd";
import ActivityStreamLine from "../activityStreamLine/ActivityStreamLine";
import { issueApis } from "../../../api/Issue";

const IssueActivityStreamLine = ({ activeTab }: { activeTab: string }) => {
  const [activityStreamLineData, setActivityStreamLineData] = useState<any>();
  const location = useLocation();
  const locationState = (location.state || {}) as any;
  const { data: IssueListInDetailModal } = useSelector(
    (state: RootState) => state.IssueListInDetailModal
  );
  const projectId =
    locationState.projectId ||
    locationState.id ||
    IssueListInDetailModal?.projectId;
  useEffect(() => {
    if (activeTab === "ActivityStream" && IssueListInDetailModal?.id && projectId) {
      getStatusTimeLineData();
    }
  }, [activeTab, IssueListInDetailModal, projectId]);

  const getStatusTimeLineData = async () => {
    try {
      const apiResponse: ApiResponse =
        await issueApis.fetchIssueActivityStreamlines(
          projectId,
          IssueListInDetailModal.id
        );
      const { data, status } = apiResponse;
      if (status) {
        setActivityStreamLineData(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      {activityStreamLineData && (
        <Card className="card-bordered mt-3" style={{ padding: "20px 50px" }}>
          <ActivityStreamLine groupedActivities={activityStreamLineData} />
        </Card>
      )}
    </>
  );
};

export default IssueActivityStreamLine;
